document.addEventListener('click', async function (e) {
    const btnModalEliminarCargo = e.target.closest('#btnModalEliminarCargo');
    if (!btnModalEliminarCargo) return;

    const idCargo       = btnModalEliminarCargo.getAttribute("data-id");
    const formEliminar  = document.querySelector("#formEliminarCargo");
    const modalEliminar = document.querySelector("#ModalEliminarCargo");

    if (!idCargo || !formEliminar || !modalEliminar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para eliminar el cargo.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/cargos/infoCargo?idCargo=${idCargo}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del cargo.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEliminar.classList.add('modal--show');

        const inputIdCargo = formEliminar.querySelector('#idCargoEliminar');
        const strongNombre = modalEliminar.querySelector('#nombreEliminarCargo');

        if (inputIdCargo) inputIdCargo.value      = data.idCargo     || "";
        if (strongNombre) strongNombre.textContent = data.nombreCargo || "";

    } catch (error) {
        console.error("Error al obtener información del cargo:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del cargo.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEliminarCargo') {
        e.preventDefault();
        const formulario    = e.target;
        const modalEliminar = document.querySelector("#ModalEliminarCargo");
        const btnSubmit     = formulario.querySelector('#btnEliminarCargo');
        const spinner       = formulario.querySelector('#spinner');
        const formData      = new FormData(formulario);
        if (!formulario || !modalEliminar || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para eliminar el cargo.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/cargos/eliminar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1000);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
                modalEliminar.classList.remove('modal--show');
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Cargo eliminado correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            modalEliminar.classList.remove('modal--show');
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
